<template>
  <section>
    <v-dialog
      v-model="showModal"
      max-width="600px"
    >
      <v-card
        color="#ECEFF1"
      >
        <br>
        <h2 class="title-style">
          <v-icon class="icon-style">
            mdi-plus
          </v-icon> Add Partner
        </h2>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
          >
            <p class="p-style">
              DBSystems New Integration Partner
            </p>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="partnerName"
                  menu-props="auto"
                  :items="partners"
                  item-value="id"
                  item-text="name"
                  label="Partner Name*"
                  dense
                  outlined
                  single-line
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="appModule"
                  menu-props="auto"
                  :items="appModules"
                  item-value="name"
                  item-text="name"
                  label="App Module*"
                  dense
                  outlined
                  single-line
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="baseUrl"
                  dense
                  outlined
                  :label="baseUrlLabel"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="partnerCategory"
                  menu-props="auto"
                  :items="partnerCategories"
                  item-value="id"
                  item-text="name"
                  label="App Module*"
                  dense
                  outlined
                  single-line
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
            </v-row>
          </v-form>
          <p class="text-sm-left">
            *Indicates required field
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red darken-3"
            @click="showModal = false;"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="#FF3700"
            @click="addNewPartner()"
          >
            Add
          </v-btn>
        </v-card-actions>
        <br>
      </v-card>
      <centre-spinner
        :loading="loading"
      />
    </v-dialog>
  </section>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'AddNewPartner',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        showModal: true,
        loading: false,
        partners: [
          { name: 'Autodesk', id: 'autodesk' }, { name: 'Xero', id: 'xero' }, { name: 'MYOB', id: 'myob' },
        ],
        partnerCategories: [
          { name: 'Payment Partner', id: 'payment_partner' }, { name: 'Project Management Partner', id: 'project_management_partner' },
        ],
        partnerName: '',
        baseUrl: '',
        appModule: '',
        partnerCategory: '',
        valid: false,
      };
    },
    computed: {
      baseUrlLabel () {
        return `${this.partnerName} Base Url*`;
      },
      appModules () {
        return this.$store.getters['organizations/getAppModules'];
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    async mounted () {
      this.loading = true;
      await this.fetchAppModules();
      this.loading = false;
    },
    methods: {
      async fetchAppModules () {
        await this.$store.dispatch('organizations/fetchAppModules');
      },
      async addNewPartner () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        await this.$store.dispatch('partners/addNewPartner', {
          name: this.partnerName,
          base_uri: this.baseUrl,
          app_module: this.appModule,
          category: this.partnerCategory,
        })
          .then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Partner created successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.loading = false;
            this.$emit('partner-success');
            this.showModal = false;
          }).catch(() => {
            this.loading = false;
          });
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
::v-deep .input-field-styling .v-label {
  font-weight: bolder;
  color: #37474F;
  font-size: 14px;
}
.p-style {
  font-size: 20px;
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  color: #546E7A;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 35px;
}
</style>
